import labels from "../../../constants/displayFields";
import { getActiveSortedPalletTypes } from "../../../utils/palletHelpers";
import { getActiveSortedUnitTypes } from "../../../utils/unitHelpers";
import { getSquareFootageTypeOptions } from "../../../utils/squareFootageHelpers";

const section = "storage";

export default function useEnabledStorage({
  onRestockInventory,
  display,
  type,
  asset,
  availableQuantityComponent,
  sameLocation,
  project,
}) {
  const palletTypeOptions = getActiveSortedPalletTypes(project?.palletTypes || [])
    .filter(pt => pt.id)
    .map(pt => [pt.id, pt.name]);
  const unitTypeOptions = getActiveSortedUnitTypes(project?.unitTypes || [])
    .filter(ut => ut.id)
    .map(ut => [ut.id, ut.name]);
  const resolvedUnitTypeOptions = unitTypeOptions.length > 0
    ? unitTypeOptions
    : [["standard_unit", "Standard Unit"]];

  const fields = [
    {
      id: "available_quantity",
      enabled: display.available_quantity,
      type: "available_quantity",
      section,
      params: {
        type: type,
        display: display,
        asset: asset,
        onRestockInventory: onRestockInventory,
        availableQuantityComponent: availableQuantityComponent,
        sameLocation: sameLocation,
      },
    },
    {
      id: "rack_locations",
      enabled: display.rack_locations,
      type: "rack_locations",
      section,
      params: {
        type: type,
        asset: asset,
      },
    },
    {
      id: "quantity_ordered",
      enabled: display.quantity_ordered,
      type: "input",
      section,
      params: {
        type: "number",
        name: "quantityOrdered",
        label: labels.quantity_ordered,
      },
    },
    {
      id: "po_number",
      enabled: display.po_number,
      type: "input",
      section,
      params: {
        type: "autoExpand",
        name: "poNumber",
        label: labels.ii_po_number,
      },
    },
    {
      id: "pallet_type",
      enabled: display.pallet_type,
      type: "select",
      section,
      params: {
        size: "small",
        name: "palletType",
        label: labels.pallet_type,
        options: palletTypeOptions,
        showNAButton: false,
      },
    },
    {
      id: "unit_type",
      enabled: display.unit_type,
      type: "select",
      section,
      params: {
        size: "small",
        name: "unitType",
        label: labels.unit_type,
        options: resolvedUnitTypeOptions,
        showNAButton: false,
      },
    },
    {
      id: "square_footage_type",
      enabled: display.square_footage_type,
      type: "select",
      section,
      params: {
        size: "small",
        name: "squareFootageType",
        label: labels.square_footage_type,
        options: getSquareFootageTypeOptions(project?.squareFootageTypes),
        showNAButton: false,
      },
    },
    {
      id: "minimum_quantity",
      enabled: display.minimum_quantity,
      type: "input",
      section,
      params: {
        type: "number",
        name: "minimumQuantity",
        label: labels.minimum_quantity,
      },
    },
    {
      id: "warehouse_quantity",
      enabled: display.warehouse_quantity,
      type: "text_field",
      section,
      params: {
        disabled: true,
        fullWidth: true,
        value: asset.warehouseQuantity,
        size: "small",
        label: labels.warehouse_quantity,
      },
    },
    {
      id: "in_cart_quantity",
      enabled: display.in_cart_quantity,
      type: "text_field",
      section,
      params: {
        disabled: true,
        fullWidth: true,
        value: asset.inCartQuantity,
        size: "small",
        label: labels.in_cart_quantity,
      },
    },
    {
      id: "allocated_quantity",
      enabled: display.allocated_quantity,
      type: "text_field",
      section,
      params: {
        disabled: true,
        fullWidth: true,
        value: asset.allocatedQuantity,
        size: "small",
        label: labels.allocated_quantity,
      },
    },
    {
      id: "reserved_quantity",
      enabled: display.reserved_quantity,
      type: "text_field",
      section,
      params: {
        disabled: true,
        fullWidth: true,
        value: asset.reservedQuantity,
        size: "small",
        label: labels.reserved_quantity,
      },
    },
  ].filter(v => v.enabled);

  return fields;
}
